import React from 'react';

import { StyledBannerImage } from './BannerImage.styles';

import { BannerImageProps } from './BannerImage.types';

import { BackgroundImage, Image, useIsBelowWidth } from '../../../';

const BannerImage = ({
  image,
  componentClassname = 'banner-image',
  customClassnames = '',
  customStyle = '',
  ...props
}: BannerImageProps) => {
  if (!image) {
    return null;
  }

  /* -------------------------------------------- */
  /* -------------- CUSTOM HOOKS ---------------- */
  /* -------------------------------------------- */

  const isTablet = useIsBelowWidth(1200);
  const isMobile = useIsBelowWidth(767);

  /* -------------------------------------------- */
  /* ------------------ MOBILE ------------------ */
  /* -------------------------------------------- */

  const mobileAspectRatio = 8 / 3;

  /* -------------------------------------------- */
  /* ----------------- DESKTOP ------------------ */
  /* -------------------------------------------- */

  const aspectRatio = '10.527%';

  return (
    <StyledBannerImage
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      {isMobile || isTablet ? (
        <div className="banner-image__mobile-tablet">
          <Image
            src={image?.url}
            imgixControlProps={{
              fit: 'clip',
            }}
            imageWidth={window.innerWidth}
            imageHeight={window.innerWidth / mobileAspectRatio}
          />
        </div>
      ) : (
        <BackgroundImage
          src={image.url}
          style={{
            margin: '0 auto',
            maxWidth: '1140px',
            background: `no-repeat center / 100% 100%`,
          }}
          imgixControlProps={{
            fit: 'clip',
            w: 1140,
            h: 1.0,
          }}
        >
          <div style={{ paddingBottom: aspectRatio }} />
        </BackgroundImage>
      )}
    </StyledBannerImage>
  );
};
BannerImage.displayName = 'BannerImage';

export default BannerImage;
